import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import { AddDistrict, getStates } from "../../actions/area";
import Spinner from "../layout/Spinner";

const AddDistrictDetails = ({
  auth: { isAuthenticated, user, users, loading },
  area: { statesData },
  onAddDistrictModalChange,
  AddDistrict,
  getStates,
  setShowAddDistrictModal,
}) => {
  useEffect(() => {
    getStates();
  }, [getStates]);

  //formData
  const [formData, setFormData] = useState({
    districtName: "",
    isSubmitted: false,
  });

  const { districtName } = formData;

  const allstates = [];
  statesData.map((state) =>
    allstates.push({
      stateId: state._id,
      label: state.stateName,
      value: state.stateName,
    })
  );

  const [state, getStateData] = useState();
  const [stateId, setStateID] = useState();

  const onStateChange = (e) => {
    //Required Validation Starts
    setError({
      ...error,
      sIdChecker: true,
      sIdErrorStyle: { color: "#000" },
    });
    //Required Validation ends
    var stateId = "";
    getStateData(e);
    stateId = e.stateId;
    setStateID(stateId);
  };

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  //Required Validation Starts
  const [error, setError] = useState({
    sIdChecker: false,
    sIdErrorStyle: {},
  });
  const { sIdChecker, sIdErrorStyle } = error;

  const checkErrors = () => {
    if (!sIdChecker) {
      setError({
        ...error,
        sIdErrorStyle: { color: "#F00" },
      });
      return false;
    }
    return true;
  };
  //Required Validation ends
  const onSubmit = (e) => {
    e.preventDefault();
    setShowAddDistrictModal(false);
    //Required Validation Starts
    if (checkErrors()) {
      const finalData = {
        districtName: districtName,
        stateId: stateId,
        districtEnteredById: user._id,
        districtEnteredByName: user.userName,
        institutionId: user.institutionId,
        userData: user,
      };

      AddDistrict(finalData);

      setFormData({
        ...formData,
        districtName: "",
        isSubmitted: true,
      });
      getStateData("");
    }
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form onSubmit={(e) => onSubmit(e)} autoComplete="off">
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <label className="label-control"> District Name* :</label>
              <input
                type="text"
                name="districtName"
                value={districtName}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <label className="label-control" style={sIdErrorStyle}>
                State* :
              </label>
              <Select
                name="stateName"
                options={allstates}
                isSearchable={true}
                value={state}
                placeholder="Select State"
                onChange={(e) => onStateChange(e)}
                theme={(theme) => ({
                  ...theme,
                  height: 26,
                  minHeight: 26,
                  borderRadius: 1,
                  colors: {
                    ...theme.colors,
                    primary: "black",
                  },
                })}
              />
            </div>
          </div>

          <div className="col-md-12 col-lg-12 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Submit"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

AddDistrictDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  AddDistrict: PropTypes.func.isRequired,
  getStates: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
});

export default connect(mapStateToProps, {
  getStates,
  AddDistrict,
})(AddDistrictDetails);
